webpackJsonp([24],{

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_icons_left_component__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_enums_wayPayment__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_lib__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_enums_gatewayCodes__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_enums_paymentStrategy__ = __webpack_require__(981);




var logout = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.$store.dispatch('clearUser');
						this.$store.dispatch('DEFAULT_USER');
						this.$store.dispatch('SET_DEFAULT_VALUES');
						this.$store.dispatch('CLEAN_PRODUCTS_ARRAY');
						// localStorage.clear();
						localStorage.removeItem('ecommerce::token');
						localStorage.removeItem('ecommerce::ecommerce-user');
						this.$store.dispatch('SET_CURRENCY_DEFAULT', this);
						if (this.getFilters && this.getFilters.length > 0) {
							this.$store.dispatch('UPDATE_PRODUCT_FILTER', this.getFilters[0].id);
						} else {
							this.$store.dispatch('UPDATE_PRODUCT_FILTER', null);
						}
						_context.next = 10;
						return this.$store.dispatch('LOAD_PRODUCTS', { context: this });

					case 10:
						this.goTo('page-home');

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function logout() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








function goTo(name) {
	this.$router.push({ name: name });
}

function borderPrimaryUserData() {
	var border = 'border-bottom: 6px solid ' + this.globalColors.primary + ';';
	var name = this.$route.name;

	return name === 'user-data-details' || name === 'edit-user-data' ? border : null;
}

function borderPrimaryUserOrder() {
	var border = 'border-bottom: 6px solid ' + this.globalColors.primary + ';';
	var name = this.$route.name;

	return name === 'user-orders' || name === 'order-detail' ? border : null;
}

function borderPrimaryFavorites() {
	var border = 'border-bottom: 6px solid ' + this.globalColors.primary + ';';
	var name = this.$route.name;

	return name === 'favorites' ? border : null;
}

function borderPrimaryAddress() {
	var border = 'border-bottom: 6px solid ' + this.globalColors.primary + ';';
	var name = this.$route.name;

	return name === 'address' ? border : null;
}

function borderPrimaryOnline() {
	var border = 'border-bottom: 6px solid ' + this.globalColors.primary + ';';
	var name = this.$route.name;

	return name === 'online-transactions' ? border : null;
}

function getUserAvatar() {
	return this.user.image || this.user.logo || this.user.urlImage || 'https://quipu-static.s3.amazonaws.com/VIERA_image/VIERA/a930a535-9156-4510-89ec-d0b44b2e397d40.jpg';
}

function isPlaceToPay() {
	var isCreditCard = this.getWaypaymentsByCommerce.find(function (w) {
		return w.code === __WEBPACK_IMPORTED_MODULE_5__shared_enums_wayPayment__["a" /* creditCard */].code;
	});
	if (isCreditCard) {
		var gatewayConfiguration = isCreditCard.gatewayConfiguration;

		var paymentLink = gatewayConfiguration.find(function (ga) {
			return ga.code === __WEBPACK_IMPORTED_MODULE_8__shared_enums_paymentStrategy__["b" /* LINK */];
		});
		var ptp = paymentLink && paymentLink.gateway.find(function (g) {
			return g.code === __WEBPACK_IMPORTED_MODULE_7__shared_enums_gatewayCodes__["k" /* placetopay */];
		});
		return !Object(__WEBPACK_IMPORTED_MODULE_6__shared_lib__["g" /* isEmpty */])(ptp);
	}
	return false;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-profile',
	components: {
		leftComponent: __WEBPACK_IMPORTED_MODULE_4__components_shared_icons_left_component__["a" /* default */]
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getWaypaymentsByCommerce', 'getFilters', 'user', 'userName']), {
		borderPrimaryAddress: borderPrimaryAddress,
		borderPrimaryFavorites: borderPrimaryFavorites,
		borderPrimaryOnline: borderPrimaryOnline,
		borderPrimaryUserData: borderPrimaryUserData,
		borderPrimaryUserOrder: borderPrimaryUserOrder,
		getUserAvatar: getUserAvatar,
		isPlaceToPay: isPlaceToPay
	}),
	methods: {
		goTo: goTo,
		logout: logout
	}
});

/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1129);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(784)("311515c2", content, true, {});

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(783)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Avenir Next Regular;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Bold;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Book;font-style:normal;font-weight:400;src:local(\"Avenir Next Book\",url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))}.profile-layout[data-v-4c3bef18]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:grid;grid-template-columns:342px 1fr;min-height:630px;margin:auto;max-width:1142px;padding-top:100px;position:relative}@media (max-width:900px){.profile-layout[data-v-4c3bef18]{grid-template-columns:1fr}}@media (max-width:768px){.profile-layout[data-v-4c3bef18]{height:auto;padding:90px 15px 0;position:relative}}.profile-menu[data-v-4c3bef18]{border-radius:7px;-webkit-box-flex:1;-ms-flex:1 1 30%;flex:1 1 30%;height:100%;padding:122px 0 0;position:relative;text-align:center}@media (max-width:768px){.profile-menu[data-v-4c3bef18]{padding:100px 0 14px}}.user-avatar-container[data-v-4c3bef18]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;top:-77px;width:100%}@media (max-width:768px){.user-avatar-container[data-v-4c3bef18]{bottom:75%}}.user-avatar-wrapper[data-v-4c3bef18]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:transparent;border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;height:148px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:148px}.user-avatar[data-v-4c3bef18]{background-color:#fff;border-radius:50%;height:128px;overflow:hidden;width:128px}.profile-info[data-v-4c3bef18]{background-color:#f5f5f5;-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,.08);box-shadow:0 0 5px 0 rgba(0,0,0,.08);-webkit-box-flex:1;-ms-flex:1 1 70%;flex:1 1 70%;height:100%;padding:17px 0;position:relative}@media (max-width:768px){.profile-info[data-v-4c3bef18]{height:auto}}.user-actions[data-v-4c3bef18]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:grid;grid-template-columns:1fr;padding:0 50px}@media (max-width:768px){.user-actions[data-v-4c3bef18]{grid-column-gap:10px;grid-template-columns:repeat(2,1fr);padding:0 75px}}.user-actions[data-v-4c3bef18],.user-name[data-v-4c3bef18]{color:#fcfcfc;font-family:Avenir Next Bold;font-size:14px;padding:0}.user-action[data-v-4c3bef18]{list-style:none;margin-bottom:15px}.user-action-btn[data-v-4c3bef18]{width:120px}.user-name[data-v-4c3bef18]{font-size:16px;margin-bottom:20px}@media (max-width:500px){.user-name[data-v-4c3bef18]{margin-bottom:35px}}.user-logout[data-v-4c3bef18]{color:#e6e6e6}@media (max-width:768px){.user-logout[data-v-4c3bef18]{grid-column:2}}.avatar-img[data-v-4c3bef18]{height:100%;-o-object-fit:contain;object-fit:contain;width:100%}.home-button-container[data-v-4c3bef18]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:0 20px;position:absolute;top:1%;width:100%;z-index:4}.home-button-container .home-button[data-v-4c3bef18]{padding:10px;-webkit-transform:rotate(180deg);transform:rotate(180deg)}", "", {"version":3,"sources":["/opt/build/repo/src/pages/page-profile.vue"],"names":[],"mappings":"AACA,WACE,gCAAmC,AACnC,kBAAmB,AACnB,gBAAoB,AACpB,wGAA2G,CAC5G,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,0GAA6G,CAC9G,AACD,WACE,2CAA8C,AAC9C,kBAAmB,AACnB,gBAAoB,AACpB,mHAAsH,CACvH,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kHAAqH,CACtH,AACD,WACE,sCAAyC,AACzC,kBAAmB,AACnB,gBAAoB,AACpB,+GAAkH,CACnH,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,2GAA8G,CAC/G,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,8BAAiC,AACjC,kBAAmB,AACnB,gBAAoB,AACpB,mGAAsG,CACvG,AACD,WACE,qCAAwC,AACxC,kBAAmB,AACnB,gBAAoB,AACpB,6GAAgH,CACjH,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kFAAqF,CACtF,AACD,iCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,aAAc,AACd,gCAAiC,AACjC,iBAAkB,AAClB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,yBACA,iCACM,yBAA2B,CAChC,CACA,AACD,yBACA,iCACM,YAAa,AACb,oBAAqB,AACrB,iBAAmB,CACxB,CACA,AACD,+BACE,kBAAmB,AACnB,mBAAoB,AAChB,iBAAkB,AACd,aAAc,AACtB,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,yBACA,+BACM,oBAAwB,CAC7B,CACA,AACD,wCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,kBAAmB,AACnB,UAAW,AACX,UAAY,CACb,AACD,yBACA,wCACM,UAAY,CACjB,CACA,AACD,sCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,6BAA8B,AAC9B,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,WAAa,CACd,AACD,8BACE,sBAAwB,AACxB,kBAAmB,AACnB,aAAc,AACd,gBAAiB,AACjB,WAAa,CACd,AACD,+BACE,yBAA0B,AAC1B,6CAAkD,AAC1C,qCAA0C,AAClD,mBAAoB,AAChB,iBAAkB,AACd,aAAc,AACtB,YAAa,AACb,eAAkB,AAClB,iBAAmB,CACpB,AACD,yBACA,+BACM,WAAa,CAClB,CACA,AACD,+BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,aAAc,AACd,0BAA2B,AAC3B,cAAgB,CACjB,AACD,yBACA,+BACM,qBAAsB,AACtB,oCAAsC,AACtC,cAAgB,CACrB,CACA,AACD,2DAEE,cAAe,AACf,6BAAgC,AAChC,eAAgB,AAChB,SAAW,CACZ,AACD,8BACE,gBAAiB,AACjB,kBAAoB,CACrB,AACD,kCACE,WAAa,CACd,AACD,4BACE,eAAgB,AAChB,kBAAoB,CACrB,AACD,yBACA,4BACM,kBAAoB,CACzB,CACA,AACD,8BACE,aAAe,CAChB,AACD,yBACA,8BACM,aAAe,CACpB,CACA,AACD,6BACE,YAAa,AACb,sBAAuB,AACpB,mBAAoB,AACvB,UAAY,CACb,AACD,wCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,eAAgB,AAChB,kBAAmB,AACnB,OAAQ,AACR,WAAY,AACZ,SAAW,CACZ,AACD,qDACI,aAAc,AACd,iCAAkC,AAC1B,wBAA0B,CACrC","file":"page-profile.vue","sourcesContent":["\n@font-face {\n  font-family: \"Avenir Next Regular\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Regular\"), url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Italic\"), url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Ultra Light\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light\"), url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Ultra Light Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light Italic\"), url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Medium\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Condensed\"), url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Medium Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Italic\"), url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Demi Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Demi Italic\"), url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Bold\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Bold\"), url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Heavy\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy\"), url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Heavy Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy Italic\"), url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Book\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next Book\", url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"));\n}\n.profile-layout[data-v-4c3bef18] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: grid;\n  grid-template-columns: 342px 1fr;\n  min-height: 630px;\n  margin: auto;\n  max-width: 1142px;\n  padding-top: 100px;\n  position: relative;\n}\n@media (max-width: 900px) {\n.profile-layout[data-v-4c3bef18] {\n      grid-template-columns: 1fr;\n}\n}\n@media (max-width: 768px) {\n.profile-layout[data-v-4c3bef18] {\n      height: auto;\n      padding: 90px 15px 0;\n      position: relative;\n}\n}\n.profile-menu[data-v-4c3bef18] {\n  border-radius: 7px;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 30%;\n          flex: 1 1 30%;\n  height: 100%;\n  padding: 122px 0 0;\n  position: relative;\n  text-align: center;\n}\n@media (max-width: 768px) {\n.profile-menu[data-v-4c3bef18] {\n      padding: 100px 0px 14px;\n}\n}\n.user-avatar-container[data-v-4c3bef18] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  position: absolute;\n  top: -77px;\n  width: 100%;\n}\n@media (max-width: 768px) {\n.user-avatar-container[data-v-4c3bef18] {\n      bottom: 75%;\n}\n}\n.user-avatar-wrapper[data-v-4c3bef18] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: transparent;\n  border-radius: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 148px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 148px;\n}\n.user-avatar[data-v-4c3bef18] {\n  background-color: white;\n  border-radius: 50%;\n  height: 128px;\n  overflow: hidden;\n  width: 128px;\n}\n.profile-info[data-v-4c3bef18] {\n  background-color: #f5f5f5;\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.08);\n          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.08);\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 70%;\n          flex: 1 1 70%;\n  height: 100%;\n  padding: 17px 0px;\n  position: relative;\n}\n@media (max-width: 768px) {\n.profile-info[data-v-4c3bef18] {\n      height: auto;\n}\n}\n.user-actions[data-v-4c3bef18] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: grid;\n  grid-template-columns: 1fr;\n  padding: 0 50px;\n}\n@media (max-width: 768px) {\n.user-actions[data-v-4c3bef18] {\n      grid-column-gap: 10px;\n      grid-template-columns: repeat(2, 1fr);\n      padding: 0 75px;\n}\n}\n.user-name[data-v-4c3bef18],\n.user-actions[data-v-4c3bef18] {\n  color: #fcfcfc;\n  font-family: \"Avenir Next Bold\";\n  font-size: 14px;\n  padding: 0;\n}\n.user-action[data-v-4c3bef18] {\n  list-style: none;\n  margin-bottom: 15px;\n}\n.user-action-btn[data-v-4c3bef18] {\n  width: 120px;\n}\n.user-name[data-v-4c3bef18] {\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n@media (max-width: 500px) {\n.user-name[data-v-4c3bef18] {\n      margin-bottom: 35px;\n}\n}\n.user-logout[data-v-4c3bef18] {\n  color: #e6e6e6;\n}\n@media (max-width: 768px) {\n.user-logout[data-v-4c3bef18] {\n      grid-column: 2;\n}\n}\n.avatar-img[data-v-4c3bef18] {\n  height: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n  width: 100%;\n}\n.home-button-container[data-v-4c3bef18] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 0 20px;\n  position: absolute;\n  top: 1%;\n  width: 100%;\n  z-index: 4;\n}\n.home-button-container .home-button[data-v-4c3bef18] {\n    padding: 10px;\n    -webkit-transform: rotate(180deg);\n            transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-admin',[_c('section',{staticClass:"profile-layout"},[_c('div',{staticClass:"home-button-container"},[_c('button',{staticClass:"home-button",attrs:{"type":"button"},on:{"click":function($event){_vm.goTo('page-home')}}},[_c('left-component')],1)]),_vm._v(" "),_c('div',{staticClass:"profile-menu",style:(("background-color: " + (_vm.globalColors.title) + ";"))},[_c('div',{staticClass:"user-avatar-container"},[_c('div',{staticClass:"user-avatar-wrapper",style:(("border: 2px solid " + (_vm.globalColors.primary) + ";"))},[_c('div',{staticClass:"user-avatar"},[_c('img',{staticClass:"avatar-img",attrs:{"src":_vm.getUserAvatar,"alt":"user-avatar"}})])])]),_vm._v(" "),_c('h3',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.userName))]),_vm._v(" "),_c('ul',{staticClass:"user-actions"},[_c('li',{staticClass:"user-action"},[_c('button',{class:['user-action-btn'],style:(_vm.borderPrimaryUserData),on:{"click":function($event){_vm.goTo('user-data')}}},[_vm._v("\n\t\t\t\t\t\tMis Datos\n\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"user-action"},[_c('button',{class:['user-action-btn'],style:(_vm.borderPrimaryUserOrder),on:{"click":function($event){_vm.goTo('user-orders')}}},[_vm._v("\n\t\t\t\t\t\tMis Órdenes\n\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"user-action"},[_c('button',{class:['user-action-btn'],style:(_vm.borderPrimaryFavorites),on:{"click":function($event){_vm.goTo('favorites')}}},[_vm._v("\n\t\t\t\t\t\tMis Favoritos\n\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"user-action"},[_c('button',{class:['user-action-btn'],style:(_vm.borderPrimaryAddress),on:{"click":function($event){_vm.goTo('address')}}},[_vm._v("\n\t\t\t\t\t\tDirecciones\n\t\t\t\t\t")])]),_vm._v(" "),(_vm.isPlaceToPay)?_c('li',{staticClass:"user-action"},[_c('button',{class:['user-action-btn'],style:(_vm.borderPrimaryOnline),on:{"click":function($event){_vm.goTo('online-transactions')}}},[_vm._v("\n\t\t\t\t\t\tMis pagos online\n\t\t\t\t\t")])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"user-action user-logout"},[_c('button',{staticClass:"user-action-btn",style:(("border-bottom: 6px solid " + (_vm.globalColors.dark) + ";")),on:{"click":_vm.logout}},[_vm._v("\n\t\t\t\t\t\tCerrar sesión\n\t\t\t\t\t")])])])]),_vm._v(" "),_c('div',{staticClass:"profile-info"},[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_profile_vue__ = __webpack_require__(1019);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c3bef18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_profile_vue__ = __webpack_require__(1130);
function injectStyle (ssrContext) {
  __webpack_require__(1128)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c3bef18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c3bef18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return datafast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return leadgods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return niubiz; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return pagopluxLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pagoplux; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return paymentez; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return placetopay; });
/* unused harmony export visa */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return xchange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mercadopagoMp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mercadopago; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return openpay; });
var datafast = 'datafast';
var leadgods = 'leadgods';
var niubiz = 'niubiz';
var pagopluxLink = 'pagoplux_link';
var pagoplux = 'pagoplux';
var paymentez = 'paymentez';
var placetopay = 'placetopay';
var visa = 'visa';
var xchange = 'xchange';
var alignet = 'alignet';
var mercadopagoMp = 'mercadopagoMp';
var mercadopago = 'mercadopago';
var openpay = 'openpay';

/***/ }),

/***/ 926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//


function clicked() {
	this.$emit('click', this.value);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'heart-component',
	inheritAttrs: false,
	methods: {
		clicked: clicked
	},
	props: {
		value: false
	}
});

/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_component_vue__ = __webpack_require__(926);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e6592f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_left_component_vue__ = __webpack_require__(980);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e6592f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_left_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.clicked}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"20","viewBox":"0 0 13 20"}},[_c('path',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#979797","stroke-width":"3","d":"M12 2l-9 8 9 8"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 981:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTTON; });
var LINK = 'PAYMENT_LINK';
var BUTTON = 'PAYMENT_BUTTON';

/***/ })

});


// WEBPACK FOOTER //
// static/js/24.a4bc71bc8272c98f57c8.js